import { createUserRepository, getUserRepository } from './';
const validateAndCreateRepo = async (props) => {
    const repoConfig = props?.functionalConfig?.repoConfig?.syncRepository;
    const name = repoConfig?.name;
    const type = repoConfig?.type;
    if (!name) {
        return;
    }
    getUserRepository(name)
        .catch((err) => {
        if (err.code === 404) {
            createUserRepo(name, type);
        }
    });
};
const createUserRepo = async (name, type) => {
    createUserRepository({ name, type });
};
export default validateAndCreateRepo;
